import * as React from 'react';
import { Component } from 'react';
import styles from '../styles/wizards/EditMyCompanyMemberEmploymentGeneralGroupWizard.scss';
import autobind from 'autobind-decorator';
import {
  __,
  convertHoursToMinutes,
  convertMinutesToHours,
  mapStateToProps,
  setTableParams,
  validateForm,
} from '../core/utils';
import { withRouter } from 'react-router';
import { setNotification } from '../redux/actions/general/notification';
import * as _ from 'lodash';
import EditDataIcon from '../assets/images/edit-specification-code-64x64.svg';
import {
  readCompanyMember,
  updateCompanyMemberEmploymentTermsGeneralData,
} from '../redux/actions/table/my_company_members';
import EditMyCompanyMemberEmploymentGeneralGroupForm from '../forms/edit_my_company_member_employment_general_group_wizard/EditMyCompanyMemberEmploymentGeneralGroupForm.js';
import EditMyCompanyMemberEmploymentGeneralFutureGroupForm from '../forms/edit_my_company_member_employment_general_group_wizard/EditMyCompanyMemberEmploymentGeneralFutureGroupForm.js';
import moment from 'moment';

@mapStateToProps((state) => ({
  store: _.get(state.table, 'my_company_members'),
}))
@withRouter
class EditMyCompanyMemberEmploymentGeneralGroupWizard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: '01',
      steps: [
        {
          id: '01',
          title: __('wizard.my-company-members.title.general-current-group'),
        },
        {
          id: '02',
          title: __('wizard.my-company-members.title.general-future-group'),
        },
      ],
    };
  }
  @autobind
  _setActiveStep(id) {
    this.setState({ active: id });
  }
  @autobind
  _handleSubmitCurrent(formData) {
    const { store } = this.props;

    const prior_work_experience = formData?.prior_work_experience;

    // Ako postoji npr vrijednost "12-11-05"
    let prior_work_experience_years = 0;
    let prior_work_experience_months = 0;
    let prior_work_experience_days = 0;

    if (prior_work_experience) {
      const parts = prior_work_experience
        .split('-')
        .map((x) => parseInt(x, 10) || 0);
      prior_work_experience_years = parts[0] || 0;
      prior_work_experience_months = parts[1] || 0;
      prior_work_experience_days = parts[2] || 0;
    }

    let data = {
      ...formData,
      user_id: store.flyout.details.id,
      //   monday_minutes: convertHoursToMinutes(formData?.monday_minutes),
      logs_time: formData?.logs_time === 'true' ? true : false,
      prior_work_experience_years,
      prior_work_experience_months,
      prior_work_experience_days,
      company_employment_date: formData.company_employment_date
        ? moment(formData.company_employment_date, 'DD.MM.YYYY').format(
            'YYYY-MM-DD'
          )
        : null,
    };

    return validateForm(
      updateCompanyMemberEmploymentTermsGeneralData(data).then(() => {
        readCompanyMember(this.props.store.flyout.details.id).then(
          ({ response }) => {
            setNotification(
              __(
                'my-company-members.employment-terms.current-general-group.updated'
              )
            );

            setTableParams('my_company_members', {
              flyout: response.data,
            });

            this.props.onClose();
          }
        );
      })
    );
  }

  @autobind
  _handleSubmitFuture(formData) {
    const { store } = this.props;

    const prior_work_experience = formData?.prior_work_experience;

    let prior_work_experience_years = 0;
    let prior_work_experience_months = 0;
    let prior_work_experience_days = 0;

    if (prior_work_experience) {
      const parts = prior_work_experience
        .split('-')
        .map((x) => parseInt(x, 10) || 0);
      prior_work_experience_years = parts[0] || 0;
      prior_work_experience_months = parts[1] || 0;
      prior_work_experience_days = parts[2] || 0;
    }

    let data = {
      ...formData,
      user_id: store.flyout.details.id,
      logs_time: formData?.logs_time === 'true' ? true : false,
      prior_work_experience_years,
      prior_work_experience_months,
      prior_work_experience_days,
      company_employment_date: formData.company_employment_date
        ? moment(formData.company_employment_date, 'DD.MM.YYYY').format(
            'YYYY-MM-DD'
          )
        : null,
      is_new: true,
    };

    return validateForm(
      updateCompanyMemberEmploymentTermsGeneralData(data).then(() => {
        readCompanyMember(this.props.store.flyout.details.id).then(
          ({ response }) => {
            setNotification(
              __(
                'my-company-members.employment-terms.future-general-group.updated'
              )
            );

            setTableParams('my_company_members', {
              flyout: response.data,
            });

            this.props.onClose();
          }
        );
      })
    );
  }

  render() {
    const { employmentGeneralData } = this.props.store;

    const { steps, active } = this.state;

    return (
      <>
        <div className={styles.header}>
          <div className={styles.title}>
            <div className={styles.left}>
              <span>
                {__(
                  'wizard.my-company-members.title.edit-my-company-member-employment-general-group'
                )}
              </span>
              <span>
                {__(
                  'wizard.my-company-members.subtitle.edit-my-company-member-employment-general-group'
                )}
              </span>
            </div>
            <div className={styles.right}>
              <EditDataIcon />
            </div>
          </div>
          <div className={styles.steps}>
            {_.map(steps, (step, i) => (
              <div
                key={i}
                onClick={() => this._setActiveStep(step.id)}
                className={`
                ${styles.step} 
                ${active === step.id ? styles.active : ''}
              `}
              >
                <span>{step.id}</span>
                <span>{step.title}</span>
              </div>
            ))}
          </div>{' '}
        </div>

        {/* TAB CONTENT */}
        <div className={styles.body}>
          {active === '01' && (
            <EditMyCompanyMemberEmploymentGeneralGroupForm
              onSubmit={this._handleSubmitCurrent}
              initialValues={{
                address_book_company_id:
                  employmentGeneralData?.current?.address_book_company_id ||
                  null,
                company_segment_id:
                  employmentGeneralData?.current?.company_segment_id || null,
                work_place: employmentGeneralData?.current?.work_place || null,
                company_position_id:
                  employmentGeneralData?.current?.company_position_id || null,
                type: employmentGeneralData?.current?.type || null,
                logs_time:
                  String(employmentGeneralData?.current?.logs_time) || null,
                // prior_work_experience:
                //   employmentGeneralData?.current?.prior_work_experience,
                prior_work_experience:
                  `${employmentGeneralData?.current?.prior_work_experience_years} ${employmentGeneralData?.current?.prior_work_experience_months} ${employmentGeneralData?.current?.prior_work_experience_days}` ||
                  null,
                // company_employment_date:
                //  employmentGeneralData?.current?.company_employment_date ||
                //  null,
                company_employment_date: employmentGeneralData?.current
                  ?.company_employment_date
                  ? moment(
                      employmentGeneralData?.current?.company_employment_date
                    ).format('DD.MM.YYYY')
                  : null,
                general_start_date:
                  employmentGeneralData?.current?.general_start_date || null,
                general_end_date:
                  employmentGeneralData?.current?.general_end_date || null,
                // monday_minutes: convertMinutesToHours(
                //   employmentDaysData?.current?.monday_minutes
                // ),
              }}
            />
          )}

          {active === '02' && (
            <EditMyCompanyMemberEmploymentGeneralFutureGroupForm
              onSubmit={this._handleSubmitFuture}
              initialValues={{
                address_book_company_id:
                  employmentGeneralData?.future?.address_book_company_id ||
                  null,
                company_segment_id:
                  employmentGeneralData?.future?.company_segment_id || null,
                work_place: employmentGeneralData?.future?.work_place || null,
                company_position_id:
                  employmentGeneralData?.future?.company_position_id || null,
                type: employmentGeneralData?.future?.type || null,
                logs_time:
                  String(employmentGeneralData?.future?.logs_time) || null,
                prior_work_experience:
                  `${employmentGeneralData?.future?.prior_work_experience_years} ${employmentGeneralData?.future?.prior_work_experience_months} ${employmentGeneralData?.current?.prior_work_experience_days}` ||
                  null,
                // company_employment_date:
                //  employmentGeneralData?.future?.company_employment_date ||
                //  null,
                company_employment_date: employmentGeneralData?.future
                  ?.company_employment_date
                  ? moment(
                      employmentGeneralData?.future?.company_employment_date
                    ).format('DD.MM.YYYY')
                  : null,
                general_start_date:
                  employmentGeneralData?.future?.general_start_date || null,
                general_end_date:
                  employmentGeneralData?.future?.general_end_date || null,
              }}
            />
          )}
        </div>
      </>
    );
  }
}

export default EditMyCompanyMemberEmploymentGeneralGroupWizard;
